import { z } from "zod";
import apiClient from "../../../shared/api/client";

export const integrationStatusSchema = z.enum(["active", "inactive"]);

export type IntegrationStatus = z.infer<typeof integrationStatusSchema>;

export const integrationSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  status: integrationStatusSchema,
  lastSyncAt: z.string().datetime({ offset: true }).nullable(),
  consecutiveFailures: z.number().int().nonnegative().default(0),
  userId: z.number().int().positive().nullable().default(null),
  userName: z.string().nullable().default(null),
  userEmail: z.string().nullable().default(null),
});

export type Integration = z.infer<typeof integrationSchema>;

export type IntegrationFilters = {
  search?: string;
  status?: IntegrationStatus | "all";
  page?: number;
  pageSize?: number;
};

const integrationsResponseSchema = z.object({
  data: z.array(integrationSchema),
  meta: z.object({
    page: z.number(),
    pageSize: z.number(),
    total: z.number(),
  }),
});

export type IntegrationsResponse = z.infer<typeof integrationsResponseSchema>;

export const fetchIntegrations = async (
  filters: IntegrationFilters
): Promise<IntegrationsResponse> => {
  const response = await apiClient.get("/integrations", {
    timeout: 15000,
    params: {
      search: filters.search,
      status: filters.status === "all" ? undefined : filters.status,
      page: filters.page ?? 1,
      pageSize: filters.pageSize ?? 10,
    },
  });

  return integrationsResponseSchema.parse(response.data);
};
